"use strict";
/*
 * Created on 30. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * Record of Release Impact report
 * (as defined in https://docs.google.com/spreadsheets/d/14uxlkhab9sC1a_hXB6Wv957gdjrZYQXHgdZJdW0AQzM/edit).
 * Entity key is: releaseId, categoryId, priceZoneId
 *
 * @author Radek Beran
 */


var ImpactRecord =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ImpactRecord, _DomainObject_1$Domai);

  // Note: old values are values before repricing, new values are values after repricing

  /**
   * Creates new record of impact report.
   *
   * Yieldigo returns forecast value always for 30 days, so it must be first recomputed
   * to one day and then for time interval of already computed report.
   *
   * @param id unique database identifier of impact record
   * @param releaseId
   * @param categoryId
   * @param priceZoneId
   * @param priceChange number of products suggested to re-pricing (number of products with exported flag)
   * @param priceSticker computed as priceChange * number of stores from price zone
   * @param marginConstraint min-max margin constraint for category and price zone (from release settings)
   * @param optimizationGoal optimization goal from release settings for category and price zone
   * @param marginOld (time dependent) computed as bm2 = actual regular price - purchase price + vendor allowances;
   * (vendor allowances = purchase price * % va from VendorAllowance entity)
   * on the category level it is sum from items (and for all computed price zones)
   * @param marginOldPercent (time dependent) computed as
   * bm2 = [(actual regular price - purchase price + vendor allowances)/actual regular price] * 100 [%];
   * (vendor allowances = purchase price * % va from VendorAllowance entity)
   * the same weight as for marginOld is used
   * @param marginNew (time dependent) computed as bm2 = new final price - purchase price + vendor allowances;
   * similar conditions as for marginOld apply;
   * TODO RBe: Add color indicator if the margin is inside margin constraint interval (leave this on FE?)
   * @param marginNewPercent (time dependent) computed as
   * bm2 = [(new final price - purchase price + vendor allowances)/new final price] * 100 [%]
   * (vendor allowances = purchase price * % va from VendorAllowance entity)
   * @param marginImpact (time dependent) computed as (marginNew - marginOld) [CZK]
   * @param marginImpactPercent (time dependent) computed as (marginNewPercent - marginOldPercent) [%]
   * @param salesVolumeOld (time dependent) oldForecast from Yieldigo (expected regular sold amount
   * in unit (kg, ks, ...) by using current regular price for reported days).
   * @param salesVolumeNew (time dependent) newForecast from Yieldigo (expected regular sold amount
   * in unit (kg, ks, ...) by using new final price for reported days)
   * @param salesVolumeImpact (time dependent) computed as salesVolumeNew - salesVolumeOld [unit of sales volume (kg, ks, ...)]
   * @param salesVolumeImpactPercent (time dependent) computed as [(salesVolumeNew - salesVolumeOld)/salesVolumeOld] * 100 [%]
   * @param revenueOld (time dependent) computed as salesVolumeOld * actual regular price [CZK]; for computing for the whole category,
   * sum of item values is used (for all computed price zones)
   * @param revenueNew (time dependent) computed as salesVolumeNew * new final price [CZK]; for computing for the whole category,
   * sum of item values is used (for all computed price zones)
   * @param revenueImpact (time dependent) computed as (revenueNew - revenueOld) [CZK]
   * @param revenueImpactPercent (time dependent) computed as [(revenueNew - revenueOld)/revenueOld] * 100 [%]
   * @param profitOld (time dependent) computed as (actual regular price - actual purchase price) [CZK];
   * for computing for the whole category, sum of item values is used (for all computed price zones)
   * @param profitOldPercent (time dependent) computed as [(regular price - purchase price)/regular price] * 100 [%];
   * for computing for the whole category, weighted average of item values is used (for all computed price zones)
   * @param profitNew (time dependent) computed as (new final price - actual purchase price) [CZK];
   * for computing for the whole category, sum of item values is used (for all computed price zones)
   * @param profitNewPercent (time dependent) computed as [(final price - purchase price)/final price] * 100 [%];
   * for computing for the whole category, weighted average is used (for all computed price zones)
   * @param profitImpact (time dependent) computed as (profitNew - profitOld) [CZK]
   * @param profitImpactPercent (time dependent) computed as [(profitNew - profitOld)/profitOld] * 100 [%]
   */
  function ImpactRecord(id, releaseId, categoryId, priceZoneId, priceChange, priceSticker, marginConstraint, optimizationGoal, // marze (margin)
  marginOld, marginOldPercent, marginNew, marginNewPercent, marginImpact, marginImpactPercent, // objem prodeju (quantity or also sales volume)
  salesVolumeOld, salesVolumeNew, salesVolumeImpact, salesVolumeImpactPercent, // prijmy (sales or also revenue)
  revenueOld, revenueNew, revenueImpact, revenueImpactPercent, // zisk (profit)
  profitOld, profitOldPercent, // added in LOG-5028 (BM1 %)
  profitNew, profitNewPercent, // added in LOG-5028 (Exp.BM1 %)
  profitImpact, profitImpactPercent) {
    var _this;

    _classCallCheck(this, ImpactRecord);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImpactRecord).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.categoryId = categoryId;
    _this.priceZoneId = priceZoneId;
    _this.priceChange = priceChange;
    _this.priceSticker = priceSticker;
    _this.marginConstraint = marginConstraint;
    _this.optimizationGoal = optimizationGoal;
    _this.marginOld = marginOld;
    _this.marginOldPercent = marginOldPercent;
    _this.marginNew = marginNew;
    _this.marginNewPercent = marginNewPercent;
    _this.marginImpact = marginImpact;
    _this.marginImpactPercent = marginImpactPercent;
    _this.salesVolumeOld = salesVolumeOld;
    _this.salesVolumeNew = salesVolumeNew;
    _this.salesVolumeImpact = salesVolumeImpact;
    _this.salesVolumeImpactPercent = salesVolumeImpactPercent;
    _this.revenueOld = revenueOld;
    _this.revenueNew = revenueNew;
    _this.revenueImpact = revenueImpact;
    _this.revenueImpactPercent = revenueImpactPercent;
    _this.profitOld = profitOld;
    _this.profitOldPercent = profitOldPercent;
    _this.profitNew = profitNew;
    _this.profitNewPercent = profitNewPercent;
    _this.profitImpact = profitImpact;
    _this.profitImpactPercent = profitImpactPercent;
    return _this;
  }

  _createClass(ImpactRecord, null, [{
    key: "initial",
    value: function initial(releaseId, categoryId, priceZoneId) {
      return new ImpactRecord(utils_1.Utils.VOID_ID, releaseId, categoryId, priceZoneId, big_decimal_1.bigdecimal(0), big_decimal_1.bigdecimal(0), null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    }
  }]);

  return ImpactRecord;
}(DomainObject_1.DomainObject);

exports.ImpactRecord = ImpactRecord;
ImpactRecord.EMPTY = ImpactRecord.initial('', '', null);